import {LegacyRegulationWrapper} from "../legacy-regulation-wrapper";
import {IRegulationComponents} from "../regulation-components.interface";
import {DelawareRegulationComponents} from "./components/delaware.regulation-components";

export class DelawareRegulation extends LegacyRegulationWrapper {
    get components(): IRegulationComponents {
        return new DelawareRegulationComponents(this.services);
    }
}